<template>
    <transition name="fade">
        <div>
            <img class="Terms-logoCookiesPolitics" ref="logo" src="@/assets/img/logo.svg" alt="Carta Blanca" />
            <!-- <div class="Terms-close" @click="$emit('close')" /> -->
            <div class="TermsTextCookiesPolitics" id="Cookies-policy" v-html="cookies"></div>
            <!-- OneTrust Cookies List start -->
            <div id="ot-sdk-cookie-policy" data-document-language="true"> </div>
            <!-- OneTrust Cookies List end -->
        </div>
    </transition>
</template>

<script>
/* global Optanon */
export default {
    data() {
        return {
            cookies: "",
        }
    },
    globals: {
        Optanon: 'readonly'
    },
    watch: {
    '$route.path'(newPath) {
      if (newPath === '/cookies') {
        this.$nextTick(() => {
          setTimeout(() => {
            if (typeof Optanon !== 'undefined' && typeof Optanon.initializeCookiePolicyHtml === 'function') {
              Optanon.initializeCookiePolicyHtml();
            } else {
              console.warn('OneTrust not yet loaded or method missing');
            }
          }, 500);
        });
      }
     }
    },
    async mounted() {
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = () => {
            if (xhttp.readyState == 4 && xhttp.status == 200) {
                this.cookies = xhttp.responseText
                    .replace("{", "")
                    .replace('"body":"', "")
                    .replace('";', "")
                    .replace("}", "")
                    .replace("}", "");

                console.log('this.cookies', this.cookies)
            }
        };
        xhttp.open(
            "GET",
            "https://api-mx-marketing.azure-api.net/sitios/cookies/aviso/V2" +
            "?ref=" +
            Math.random() * 9999,
            true,
        );
        xhttp.send();

        if (this.$route.path === '/cookies') {
            this.$nextTick(() => {
                setTimeout(() => {
                if (typeof Optanon !== 'undefined' && typeof Optanon.initializeCookiePolicyHtml === 'function') {
                    Optanon.initializeCookiePolicyHtml();
                }
                }, 500);
           });
        }
    },
    props: {
        visible: {
            type: Boolean,
        },
    },
    // components: {
    //     TycosText,
    // },
}
</script>

<style lang="css" >
.Terms-logoCookiesPolitics {
    width: 85px;
    position: absolute 40px 30px;
}


.TermsTextCookiesPolitics {
    margin-bottom: 30px;
    text-align: justify;
    max-width: 960px;
    margin: 0 auto;
    color: #464646;
    width: 75vw;
}

.TermsTextCookiesPolitics>div>table {
    width: 100% !important;
    border-collapse: collapse !important;
    border-collapse: collapse;
    border-spacing: 0;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin: 2.5rem 0;
    overflow: auto;
    padding: 1rem
}

.TermsTextCookiesPolitics th,
td,
tr {
    border: 1px solid;
    font-size: 1.2vw !important;
    padding: 5px;
}

.TermsTextCookiesPolitics h2,
h3,
p {
    margin: 0;
}

.TermsTextCookiesPolitics h2,
h3 {
    text-transform: uppercase;
}

.CookiesPolitics h2 {
    font-size: 40px;
    font-weight: 900;
    line-height: 1.2em;
    margin-bottom: 1em;
    color: WESTAR;
}

.TermsTextCookiesPolitics h3 {
    letter-spacing: 0.1em;
}

.TermsTextCookiesPolitics p {
    margin-bottom: 1.5em;
    font-size: 19px;
}
</style>